module.exports = {"230505001":"振兴中路街道","230505002":"振兴东路街道","230505004":"集贤街道","230505005":"东荣街道","230505101":"太保镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230505.json
// module id = 814
// module chunks = 0